// store.ts
import { configureStore } from '@reduxjs/toolkit';
import breadcrumbsReducer from './reducers';

const store = configureStore({
    reducer: {
        breadcrumbs: breadcrumbsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
